import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { useMemo } from 'react';
import classNames from 'classnames';
import { SelectList } from '../../SelectList/SelectList.es.js';

const MultiSelectDropdownOptions = ({ loading, items, locale, highlightedIndex, getItemProps, getMenuProps, truncate = true, maxMenuItems = 6, innerRef, ...props })=>{
    const noItems = items.length === 0;
    const content = useMemo(()=>{
        if (loading) {
            return jsx(SelectList.Loading, {});
        }
        if (noItems && locale?.noItemsMessage != null) {
            return jsx(SelectList.NoItems, {
                "data-testid": "no-items-message",
                children: locale.noItemsMessage
            });
        }
        return jsx(Fragment, {
            children: items.map((item, index)=>item.header ? jsx(SelectList.Item.Header, {
                    "data-testid": "list-item-header",
                    disabled: true,
                    children: item.label
                }, index) : jsxs(SelectList.Item, {
                    ...getItemProps?.({
                        index,
                        item,
                        refKey: 'innerRef'
                    }),
                    className: classNames({
                        highlighted: highlightedIndex === index
                    }),
                    "data-testid": "list-item",
                    item: item,
                    truncate: truncate,
                    children: [
                        jsx(SelectList.Item.Description, {
                            children: item.description
                        }),
                        jsx(SelectList.Item.Icon, {
                            align: "left",
                            name: item.icon
                        }),
                        jsx(SelectList.Item.Icon, {
                            align: "right",
                            name: item.tagIcon
                        }),
                        jsx(SelectList.Item.Tag, {
                            align: "right",
                            children: item.tag
                        })
                    ]
                }, index))
        });
    }, [
        items,
        truncate,
        loading,
        locale,
        noItems,
        getItemProps,
        highlightedIndex
    ]);
    return jsx(SelectList, {
        ...props,
        ...getMenuProps?.({
            refKey: 'innerRef'
        }),
        fixedHeight: false,
        maxMenuItems: maxMenuItems,
        children: content
    });
};
MultiSelectDropdownOptions.displayName = 'MultiSelectDropdown.Options';

export { MultiSelectDropdownOptions };
//# sourceMappingURL=MultiSelectDropdown.Options.es.js.map
